export default __webpack_public_path__ + "static/media/3e82981bee191349ec38c5eddab413dc.svg";